import React, { FC } from 'react';

import { FadeInAnimatedView } from 'components/ucl';
import { useAuthContext } from 'state/auth';
import { useIsLoyaltyEnabled } from 'state/loyalty/hooks/use-is-loyalty-enabled';
import { useLoyaltyUser } from 'state/loyalty/hooks/use-loyalty-user';

import AuthenticatedBanner from './loyalty-banner-authenticated';
import { LoyaltyBannerSkeleton } from './loyalty-banner-skeleton';
import UnauthenticatedBanner from './loyalty-banner-unauthenticated';

const LoyaltyBanner: FC<React.PropsWithChildren<unknown>> = () => {
  const loyaltyEnabled = useIsLoyaltyEnabled();
  const { loyaltyUser, loading: loyaltyLoading } = useLoyaltyUser();
  const { loading: authLoading } = useAuthContext();

  const loading = loyaltyLoading || authLoading;

  if (!loyaltyEnabled) {
    return null;
  }

  if (loading) {
    return <LoyaltyBannerSkeleton />;
  }

  return (
    <FadeInAnimatedView isVisible>
      {loyaltyUser ? <AuthenticatedBanner /> : <UnauthenticatedBanner />}
    </FadeInAnimatedView>
  );
};

export default LoyaltyBanner;
